import React from "react";
import {Button} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {makeLxTranslations, useLxTranslations} from "@lxo-blocks/react";

const CANCEL_MFA_BUTTON_TRANSLATION = makeLxTranslations({
    namespace: "cancelMfaButtonTranslations",
    translations: {
        CANCEL: "Abbrechen"
    }
})

export default function CancelMfaSignInButton() {
    const navigate = useNavigate();
    const {t} = useLxTranslations(CANCEL_MFA_BUTTON_TRANSLATION);

    return (
        <>
            <Button color="secondary" onClick={() => navigate("/" + window.location.search)}>{t("CANCEL")}</Button>
        </>
    );
}